import ImageEu from '../assets/EU-projekt.jpeg'
import ImageEU2 from '../assets/montirana3.jpg'
import ImageEU3 from '../assets/montirano.jpeg'
import RHimage from '../assets/RHimage.png'
import EuFinimage from '../assets/EuFinimage.png'
import RH from '../assets/logoRH.png'
import MF from '../assets/logoFinanciraEU.png'

import {useFontSizeStore} from "../stores/useFontSizeStore";
import Pdf from "../assets/eu_projekti3.pdf";
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// 2. Import your specific icon
import { faCircle } from '@fortawesome/free-regular-svg-icons';

const EUProjects = () => {
  const langSelected = useFontSizeStore((state) => state.lang)
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const options = useFontSizeStore(state => state.defs)
  const textSizeSelected = useFontSizeStore(state => state.textSizeSelected)

  return (

      <div className="container">
          <div className="row">
              <div className="col-8">
                  <p style={options[textSizeSelected].styleOver}>{langSelected === 0 ? 'EU projekti' : 'EU Projects'}</p>
              </div>
              <div className="col-4">

              </div>
          </div>

        <div className="row mt-3">
              <div className="col-lg-5 col-sm-12">
                  <img src={RHimage} className="img-fluid" alt="EUfonds"/>
              </div>
               <div className="col-lg-5 col-sm-12">
                  <img src={EuFinimage} className="img-fluid" alt="EUfonds"/>
              </div>
          </div>


        <div className="row mt-3">
              <div className="col-12">
                  <p style={options[textSizeSelected].styleHead}>{langSelected === 0 ? 'Razvoj inovacije EkoGlide E-100 – održivo oplatno ulje za predgotovljene betonske elemente' : 'Razvoj inovacije EkoGlide E-100 – održivo oplatno ulje za predgotovljene betonske elemente'} </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                     Pinky-s d.o.o. provodi projekt istraživanja i razvoja inovativnog oplatnog ulja EkoGlide E-100, namijenjenog olakšanom odvajanju betona od kalupa u proizvodnji predgotovljenih betonskih elemenata. Ključna inovacija proizvoda je zamjena svježeg biljnog ulja pročišćenim otpadnim jestivim uljem, čime se svježa sirovina zamjenjuje sekundarnom te se doprinosi kružnom gospodarstvu, smanjenju otpada i održivijoj proizvodnji u građevinskoj industriji. Cilj projekta je izrada i dokazivanje funkcionalnog prototipa te priprema proizvoda za komercijalizaciju
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormalBold}>
                      {langSelected === 0 ? 'Ciljevi projekta su:' : 'Ciljevi projekta su:.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
                                    
                      razvoj inovativnog oplatnog ulja EkoGlide E-100 na bazi pročišćenog otpadnog biljnog ulja
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
                      izrada i dokazivanje funkcionalnog prototipa proizvoda te potvrda tehnološke izvedivosti
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
   
                      smanjenje ekološkog otiska proizvodnje kroz kružno korištenje sirovina
                    
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
                      jačanje istraživačko-razvojnih i inovacijskih kapaciteta poduzeća
                  </p>
              </div>
          </div>
           <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
                      priprema proizvoda za tržište kroz izradu strategije i plana komercijalizacije.
                  </p>
              </div>
          </div>

            <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormalBold}>
                      {langSelected === 0 ? 'Očekivani rezultati:' : 'Očekivani rezultati:'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
                      razvijen i testiran prototip oplatnog ulja EkoGlide E-100
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
   
                      uspješno dokazan inovativni koncept proizvoda
                    
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
                      izrađena analiza tržišta i studija isplativosti te strategija i plan komercijalizacije
                  </p>
              </div>
          </div>
           <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                    <FontAwesomeIcon 
                        icon={faCircle} 
                        style={{ 
                            backgroundColor: '#333', /* Fills in the circle */
                            borderRadius: '50%', 
                            fontSize: '8px',         /* Controls dot size */
                            marginRight: '12px'      /* Space after the dot */
                        }} 
                        />
                      povećanje konkurentnosti poduzeća i proširenje asortimana održivih proizvoda.
                  </p>
              </div>
          </div>

        <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                     Projekt dodatno učvršćuje poziciju Pinky-s d.o.o. kao tehnološki orijentiranog poduzeća koje ulaže u istraživanje i razvoj novih proizvoda, s naglaskom na održivost, kružno gospodarstvo i učinkovitije korištenje resursa u građevinskoj industriji.
                  </p>
              </div>
          </div>



          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormalBold}>
                      {langSelected === 0 ? 'Detalji projekta:' : 'Detalji projekta:.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Naziv projekta: Razvoj inovacije EkoGlide E-100' : 'Naziv projekta: Razvoj inovacije EkoGlide E-100'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Naziv korisnika: PINKY-S d.o.o.' : 'Naziv korisnika: PINKY-S d.o.o.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Kod projekta: NPOO.C3.2.R3-I1.06.0258' : 'Kod projekta: NPOO.C3.2.R3-I1.06.0258'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Ukupna vrijednost projekta: 71.922,15 EUR' : 'Ukupna vrijednost projekta: 71.922,15 EUR'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Iznos bespovratnih sredstava: 50.000,00 EUR' : 'Iznos bespovratnih sredstava: 50.000,00 EUR'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Razdoblje provedbe: 30.6.2025. – 30.6.2026.' : 'Razdoblje provedbe: 30.6.2025. – 30.6.2026.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Izvor financiranja: Europska unija – NextGenerationEU (Nacionalni plan oporavka i otpornosti 2021. – 2026.)' : 'Izvor financiranja: Europska unija – NextGenerationEU (Nacionalni plan oporavka i otpornosti 2021. – 2026.)'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                     <small>Projekt dodatno učvršćuje poziciju Pinky-s d.o.o. kao tehnološki orijentiranog poduzeća koje ulaže u istraživanje i razvoj novih proizvoda, s naglaskom na održivost, kružno gospodarstvo i učinkovitije korištenje resursa u građevinskoj industriji.</small>
                  </p>
              </div>
          </div>



          <div className="row mt-3">
              <div className="col-12">
                  <p style={options[textSizeSelected].styleHead}>{langSelected === 0 ? 'Inovacijski vaučer za istraživanje i razvoj HYDROPHOBE E' : 'Inovacijski vaučer za istraživanje i razvoj HYDROPHOBE E'} </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Pinky-s d.o.o. u suradnji s Fakultetom kemijskog inženjerstva i tehnologije proveo je istraživanje i razvoj inovativnog aditiva za beton pod nazivom HYDROPHOBE E. Cilj projekta je razvoj vlastite emulzije silana visoke koncentracije koja nije dostupna na tržištu.Time će se značajno smanjiti troškovi transporta, poboljšati svojstva betona te doprinijeti održivoj gradnji' : 'Pinky-s d.o.o. u suradnji s Fakultetom kemijskog inženjerstva i tehnologije proveo je istraživanje i razvoj inovativnog aditiva za beton pod nazivom HYDROPHOBE E. Cilj projekta je razvoj vlastite emulzije silana visoke koncentracije koja nije dostupna na tržištu.Time će se značajno smanjiti troškovi transporta, poboljšati svojstva betona te doprinijeti održivoj gradnji.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormalBold}>
                      {langSelected === 0 ? 'Ciljevi projekta su:' : 'Ciljevi projekta su:.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Razvoj inovativnog aditiva HYDROPHOBE E' : 'Razvoj inovativnog aditiva HYDROPHOBE E.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Poboljšanje svojstava betona i smanjenje rasta mikroorganizama' : 'Poboljšanje svojstava betona i smanjenje rasta mikroorganizama.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Smanjenje troškova nabave i transporta sirovina' : 'Smanjenje troškova nabave i transporta sirovina.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Povećanje trajnosti betonskih proizvoda' : 'Povećanje trajnosti betonskih proizvoda.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormalBold}>
                      {langSelected === 0 ? 'Očekivani rezultati:' : 'Očekivani rezultati:.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Razvijena i testirana emulzija silana visoke koncentracije' : 'Razvijena i testirana emulzija silana visoke koncentracije'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Povećanje konkurentnosti poduzeća u industriji betona' : 'Povećanje konkurentnosti poduzeća u industriji betona'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Suradnja s akademskim sektorom i prijenos znanja u industriju' : 'Suradnja s akademskim sektorom i prijenos znanja u industriju'}
                  </p>
              </div>
          </div>


          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Ovaj inovativni projekt dodatno učvršćuje poziciju Pinky-s d.o.o. kao tehnološki orijentiranog poduzeća koje ulaže u istraživanje i razvoj novih proizvoda s ciljem povećanja  održivosti i učinkovitosti u građevinskoj industriji.' : 'Ovaj inovativni projekt dodatno učvršćuje poziciju Pinky-s d.o.o. kao tehnološki orijentiranog poduzeća koje ulaže u istraživanje i razvoj novih proizvoda s ciljem povećanja  održivosti i učinkovitosti u građevinskoj industriji.'}
                  </p>
              </div>
          </div>


          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormalBold}>
                      {langSelected === 0 ? 'Detalji projekta:' : 'Detalji projekta:.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Naziv projekta: Inovacijski vaučer Pinky-s d.o.o.' : 'Naziv projekta: Inovacijski vaučer Pinky-s d.o.o.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Naziv korisnika: PINKY-S d.o.o.' : 'Naziv korisnika: PINKY-S d.o.o.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Kod projekta: PK.1.1.06.0008' : 'Kod projekta: PK.1.1.06.0008'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Ukupna vrijednost projekta: 11.100,00 EUR' : 'Ukupna vrijednost projekta: 11.100,00 EUR'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Iznos bespovratnih sredstava: 7.548,00 EUR' : 'Iznos bespovratnih sredstava: 7.548,00 EUR'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Razdoblje provedbe: 11.8.2024. - 11.12.2024.' : 'Razdoblje provedbe: 11.8.2024. - 11.12.2024.'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Izvor financiranja: Europska unija – NextGenerationEU, Europski fond za regionalni razvoj' : 'Izvor financiranja: Europska unija – NextGenerationEU, Europski fond za regionalni razvoj'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Projekt je sufinanciran sredstvima Europske unije iz Europskog fonda za regionalni razvoj. Ovaj projekt je sufinanciran u okviru Poziva „Inovacijski vaučeri za MSP-ove“.' : 'Projekt je sufinanciran sredstvima Europske unije iz Europskog fonda za regionalni razvoj. Ovaj projekt je sufinanciran u okviru Poziva „Inovacijski vaučeri za MSP-ove“.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-4 col-sm-4">
                  <img src={RH} className="img-fluid" alt="EUfonds"/>
              </div>
              <div className="col-lg-4 col-sm-4">
                  <img src={MF} className="img-fluid" alt="EUfonds"/>
              </div>
          </div>

          <div className="row mt-0">
              <div className="col-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      <a href={Pdf} target="_blank"
                         rel="noopener noreferrer"> {langSelected === 0 ? 'Detaljno' : 'Details'} </a>
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-12">
                  <p style={options[textSizeSelected].styleHead}>{langSelected === 0 ? 'Informatizacija poslovanja poduzeća PINKY-S d.o.o.' : 'Computerization of operations of the company PINKY-S d.o.o.'} </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Poduzeće Pinky-s d.o.o. renominirano je poduzeće s dugogodišnjom tradicijom u industriji betona. Razvojem poduzeća vlastita proizvodnja aditiva te automatizacija sustava betonara postala je primarna djelatnost. Dugogodišnje iskustvo vezano uz problematiku i tehnologije pri proizvodnji betona omogućilo je da izvedemo tehničko-tehnološka rješenja za bilo koji problem vezan uz betonsku industriju, koristeći se pri tome vlastitim inovacijama, programima i opremom.' : 'The company Pinky-s d.o.o. is a renowned company with a long tradition in the concrete industry. As the company developed, its own production of additives as well as the automation system of concrete plants became its primary activities. Many years of experience related to the issues and technologies in the production of concrete have enabled us to implement the technical-technological solutions for any problem related to the concrete industry, using our own innovations, programs and equipment.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'U rujnu 2019. godine, započeli smo s provedbom projekta „Informatizacija poslovnih procesa poduzeća Pinky-s d.o.o.“, koji je sufinanciran iz natječaja „Poboljšanje konkurentnosti i učinkovitosti MSP-a kroz informacijske i komunikacijske tehnologije (IKT) - 2“. Provedba projekta traje do ožujka 2021. godine. Ukupna vrijednost projekta iznosi 417.684,86 HRK, od toga dobivena bespovratna sredstva iznose 243.555,04 HRK.' : 'In September 2019, we started implementing a project, "Computerization of business processes of the company Pinky-s d.o.o.", which was co-financed through a tender "Improving the competitiveness and efficiency of SMEs through information and communication technologies (ICT) - 2". The implementation of the project lasted until March 2021. The total value was HRK 417,684.86, of which the received grant amounted to HRK 243,555.04.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Ulaganjem u informatizaciju poslovanja kroz uvođenje ERP sustava i proces automatizacije betonara  povezani su poslovni procesi poduzeća te se na taj način utjecalo na smanjenje troškova, povećanu produktivnost, olakšani su rutinski poslovi, informacije su lako dostupne te se omogućilo brže donošenje odluka.' : 'Investing in business computerization through the introduction of ERP systems, as well as the automation system of concrete plants, connects the company\'s business activities, thus reducing costs, increasing productivity, facilitating routine tasks and making information easily available, enabling faster decision-making.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Aktivnosti projekta uključuju nabavu ERP sustava te informatizaciju procesa automatizacije betonara potrebne za modernizaciju poslovanja. Projektom će se utjecati na povećanje prihoda od prodaje i te otvaranje novih radnih mjesta do 2023. godine.' : 'The project activities include a procurement of an ERP system and computerization of the automation process of the concrete plant, necessary for the modernization of the business. The project will influence an increase in sales revenue and the creation of new jobs by 2023.'}
                  </p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>
                      {langSelected === 0 ? 'Za sve dodatne informacije slobodno se obratite na kontakt:' : 'For any additional information, feel free to contact:'}
                  </p>
              </div>
          </div>
          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>Spomenka Koprivec, pinky-s@pinky-s.com, 040/ 360
                      700</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Projekt je sufinancirala Europska unija iz Europskog fonda za regionalni razvoj.' : 'The project was co-financed by the European Union from the European Fund for Regional Development.'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}
                     onClick={() => openInNewTab('https://www.strukturnifondovi.hr')}> www.strukturnifondovi.hr</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}
                     onClick={() => openInNewTab('https://strukturnifondovi.hr/eu-fondovi/esi-fondovi-2014-2020/op-konkurentnost-i-kohezija/')}>www.strukturnifondovi.hr/op-konkurentnost-i-kohezija-2014-2020-779</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <img src={ImageEu} className="img-fluid" alt="EUfonds"/>
              </div>
          </div>
          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleSub}>09/2019.</p>
              </div>
          </div>


          <div className="row mt-3">
              <div className="col-12">
                  <p style={options[textSizeSelected].styleHead}>{langSelected === 0 ? 'Povećanje proizvodnih kapaciteta provedbom projekta iz natječaja „E-impuls“' : 'Increasing production capacity through the implementation of the "E-impulse" tender project'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Sa zadovoljstvom Vas obavještavamo da provodimo projekt „Povećanje konkurentnosti poduzeća Pinky-S d.o.o. uvođenjem modernizirane opreme u proizvodni proces“ sufinanciran u okviru Javnog poziva E-impuls. Ukupna vrijednost projekta iznosi 340.281,63 HRK, dok je dobiveni iznos bespovratnih sredstva 228.669,25 HRK. Provedba projekta započela je 1. listopada 2017. godine te traje do 1. listopada 2018. godine.' : 'We are pleased to inform you that we are implementing the project "Increasing the competitiveness of the company Pinky-S d.o.o. by introducing modernized equipment into the production process". The project is co-financed through a public tender E-impuls. The total value of the project is HRK 340,281.63, while the amount received in grants is HRK 228,669.25. The implementation of the project started on October 1, 2017 and will continue until October 1, 2018.'}</p>
              </div>
          </div>

          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Kroz 12. mjeseci trajanja projekta, povećat ćemo naše proizvodne kapacitete u proizvodnji aditiva, odnosno dodataka za betonsku galanteriju za koju koristimo posebnu recepturu razvijenu i testiranu u vlastitom laboratoriju. Cilj projekta je uvođenjem nove opreme u proizvodni proces ostvariti pokazatelje projekta – očuvanje radnih mjesta, otvaranje novog radnog mjesta te povećanje prihoda od prodaje za 21,55 %.' : 'During the 12 months of the project, we will increase our production capacity of additives for concrete accessories, for which we use a special recipe developed and tested in our own laboratory. The aim of the project is to introduce new equipment into the production process, preserve jobs, create more jobs and increase sales revenue by 21.55%.'}</p>
              </div>
          </div>

          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'U pripremi i provedbi projektnih aktivnosti sudjeluju vanjski stručnjaci iz REDEA-e koji posjeduju dugogodišnje iskustvo u pripremi i provođenju projekata, provođenju postupka javne nabave, kao i savjetovanju poduzetnika.' : 'The preparation and implementation of project activities involves external experts from REDEA who have many years of experience in the preparation and implementation of  similar projects, the implementation of public procurement procedures, as well as in advising entrepreneurs.'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Za sve dodatne informacije slobodno nam se obratite:' : 'For any additional information, feel free to contact us:'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>Spomenka Koprivec, pinky-s@pinky-s.com, 040/ 360
                      700</p>
                  <p style={options[textSizeSelected].styleNormal}>Kristina Pevec, kristina.pevec@redea.hr, 040/ 395
                      572</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Projekt je sufinancirala Europska unija iz Europskog fonda za regionalni razvoj.' : 'The project was co-financed by the European Union from the European Fund for Regional Development.'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}
                     onClick={() => openInNewTab('https://www.strukturnifondovi.hr')}> www.strukturnifondovi.hr</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}
                     onClick={() => openInNewTab('https://strukturnifondovi.hr/eu-fondovi/esi-fondovi-2014-2020/op-konkurentnost-i-kohezija/')}>www.strukturnifondovi.hr/op-konkurentnost-i-kohezija-2014-2020-779</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <img src={ImageEu} className="img-fluid" alt="EUfonds"/>
              </div>
          </div>
          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleSub}>01/2019.</p>
              </div>
          </div>


          <div className="row mt-3">
              <div className="col-12">
                  <p style={options[textSizeSelected].styleHead}>{langSelected === 0 ? 'Certifikacijom proizvoda do tržišta' : 'From product certification to the market'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Poduzeće PINKY-S d.o.o. za zastupanje inozemnih tvrtki,uvoz-izvoz i ugostiteljstvo je poduzeće s dugogodišnjom tradicijom, osnovano 1993. g. Posluje u industriji betona te industriji boja i lakova, za koje nudi široku paletu proizvoda i usluga vlastite inovativne proizvodnje. Ideja proizvodnje aditiva javila se još prije desetak godina kada smo opremili vlastiti laboratorij za razvoj i krenuli s proizvodnjom aditva za betonsku galenteriju. U želji da upotpuni ponudu vlastitih proizvoda za betonsku industriju, stručni tim naših kemiskih inžinjera 2017. godine završio je i razvoj aditiva za transportne betone.' : 'The company PINKY-S d.o.o. has a long tradition. It was founded in 1993 and its core activities are in the concrete, paint and coating industry, for which it offers a wide range of products and its own innovative production processes. The idea of producing additives was born a decade ago when we equipped our own development laboratory and started producing additives for concrete accessories. In order to expand our product range in the concrete industry, in 2017, our chemical engineers completed the development of additives for ready-mix concrete/transport concrete.'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <img src={ImageEU2} className="img-fluid" alt="EUfonds2"/>
              </div>
          </div>

          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Novo razvijene proizvode prije stavljanja na tržište potrebno je certificirati i uskladiti s normama te dokazati kvalitetu, sigurnost i pouzdanost proizvoda. U tu svrhu poduzeće se prijavilo na natječaj „Certifikacijom proizvoda do tržišta“.' : 'Newly developed products must be certified and harmonized according to relevant standards before being put on the market, and the quality, safety and reliability of the product must be proven. For this purpose, the company submitted an application for a tender "Certification of products for the market".'}</p>
              </div>
          </div>

          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Nakon uspješne prijave projekta „Certificiranjem novih proizvoda poduzeća Pinky-S d.o.o. do povećanja konkurentnosti poduzeća“, poduzeće provodi projekt u razdoblju od 12. srpnja 2017. do 12. srpnja 2018. godine. Provedbom projekta certificirat će se osam vlastito razvijenih proizvoda - novih vrsta aditiva za transportni beton i beton za proizvodnju betonskih elemenata, eliminirajući problem nepostojanja certifikata i nemogućnost plasiranja novih proizvoda na tržište.' : 'After the successful application for the project "Certification of new products of the company Pinky-S d.o.o. to increase the competitiveness of the company", the company will be implementing the project in the period from July 12, 2017 to July 12, 2018. The implementation of the project will certify eight self-developed products - new types of additives for ready-mix concrete /transport concrete and concrete for the production of concrete elements, eliminating the problem of no certificate and the impossibility of placing new products on the market.'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <img src={ImageEU3} className="img-fluid" alt="EUfonds3"/>
              </div>
          </div>

          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Cilj projekta je povećanje konkurentnosti na domaćem i inozemnim tržištima putem proširenja proizvodnog asortimana što će rezultirati uvođenjem osam novih certifikata za vlastite proizvode, povećanjem prihoda od prodaje za 11,46 % i povećanjem prihoda od izvoza za 6,13 %. Ukupna vrijednost projekta iznosi 119.584,66 HRK, dok iznos dobivenih bespovratnih sredstva iznosi 92.331,00 HRK.' : 'The goal of the project is to increase competitiveness on the domestic and foreign markets by expanding the product range, which will be facilitated by the eight new certificates for our own products; it will result in an increase in sales revenue by 11.46% and an increase in export revenue by 6.13%. The total value of the project amounts to HRK 119,584.66, while the amount received in grants is HRK 92,331.00.'}</p>
              </div>
          </div>
          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'U pripremi i provedbi projektnih aktivnosti sudjeluju vanjski stručnjaci iz REDEA-e koji posjeduju dugogodišnje iskustvo u pripremi i provođenju projekata, provođenju postupka javne nabave, kao i savjetovanju poduzetnika.' : 'The preparation and implementation of project activities was helped by the experts from the regional development agency REDEA. They have many years of experience in the preparation and implementation of projects, the implementation of public procurement procedures as well as in advising entrepreneurs.'}</p>
              </div>
          </div>


          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Za sve dodatne informacije slobodno nam se obratite:' : 'For any additional information, feel free to contact us:'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>Spomenka Koprivec, pinky-s@pinky-s.com, 040/ 360
                      700</p>
                  <p style={options[textSizeSelected].styleNormal}>Kristina Pevec, kristina.pevec@redea.hr, 040/ 395
                      572</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Projekt je sufinancirala Europska unija iz Europskog fonda za regionalni razvoj.' : 'The project was co-financed by the European Union from the European Fund for Regional Development.'}</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}
                     onClick={() => openInNewTab('https://www.strukturnifondovi.hr')}> www.strukturnifondovi.hr</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleNormal}
                     onClick={() => openInNewTab('https://strukturnifondovi.hr/eu-fondovi/esi-fondovi-2014-2020/op-konkurentnost-i-kohezija/')}>www.strukturnifondovi.hr/op-konkurentnost-i-kohezija-2014-2020-779</p>
              </div>
          </div>

          <div className="row mt-3">
              <div className="col-lg-8 col-sm-12">
                  <img src={ImageEu} className="img-fluid" alt="EUfonds"/>
              </div>
          </div>
          <div className="row">
              <div className="col-lg-8 col-sm-12">
                  <p style={options[textSizeSelected].styleSub}>01/2017.</p>
              </div>
          </div>


      </div>
  );
};

export default EUProjects;
